import { Link } from 'react-router-dom';
import { ChevronRight, FileText } from 'lucide-react';

import { helpArticlePath } from '@/app/helpArticle/_helpers';

/** The articles an answer came from, each a link to it in the help centre. */
const Sources = ({ sources }) => {
  return (
    <div className="mt-3" data-testid="help-assistant-sources">
      <div className="text-muted-foreground mb-1.5 text-xs font-medium">Sources</div>
      <ul className="divide-y overflow-hidden rounded-lg border">
        {sources.map((source) => (
          <li key={source.slug}>
            <Link
              to={helpArticlePath(source.slug)}
              className="hover:bg-muted/60 group flex items-center gap-2.5 px-3 py-2 text-sm transition-colors"
              data-testid={`help-assistant-source-${source.slug}`}
            >
              <FileText className="text-muted-foreground size-4 shrink-0" />
              <span className="min-w-0 flex-1 truncate font-medium">{source.title}</span>
              <ChevronRight className="text-muted-foreground size-4 shrink-0 transition-transform group-hover:translate-x-0.5" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sources;
